import type { NavigateFunction } from "react-router";
import {
  GET_REDIRECT_SAGA,
  SAVE_REDIRECT_SAGA,
} from "../../helpers/constants";
import type { RedirectInfo } from "../../containers/RedirectInfo/types/RedirectInfo.type";

export type GetRedirectSagaAction = {
  type: typeof GET_REDIRECT_SAGA,
  id: string,
};

export type SaveRedirectSagaAction = {
  type: typeof SAVE_REDIRECT_SAGA,
  redirectId?: string,
  redirect: RedirectInfo,
  navigate: NavigateFunction,
};

export type Actions =
  GetRedirectSagaAction
  | SaveRedirectSagaAction;

export const getRedirectSaga = (id: string): GetRedirectSagaAction => ({
  type: GET_REDIRECT_SAGA,
  id,
});

// @ts-expect-error - redirectId is optional, but redirect is required
export const saveRedirect = (redirectId?: string, redirect: RedirectInfo, navigate: NavigateFunction)
: SaveRedirectSagaAction => ({
  type: SAVE_REDIRECT_SAGA,
  redirectId,
  redirect,
  navigate,
});
